import axios from "axios";
import { AxiosResponse } from "axios";
import { ITeam, ITeamResponse } from "../../../../types/ITeam";

const api = axios.create({
  withCredentials: true,
});

api.defaults.headers.Authorization = `Bearer ${localStorage.getItem(
  "accessToken"
)}`;
export default class TeamsService {
  static async getAll(query: string): Promise<AxiosResponse<ITeamResponse>> {
    return await api.get<ITeamResponse>("/api/teams" + query);
  }

  static async getOne(id: number): Promise<AxiosResponse<ITeam>> {
    return await api.get<ITeam>(`/api/teams/${id}/members`);
  }

  static async addTeamState(payload: Object): Promise<any> {
    return await api.post(`/api/teams`, payload);
  }

  static async addTeamMembers(teamId: number, payload: Object): Promise<any> {
    return await api.post(`/api/teams/${teamId}/members`, payload);
  }

  static async saveTeamState(teamId: number, payload: Object): Promise<any> {
    const response = await api.patch(`/api/teams/${teamId}`, payload);
    return response.data;
  }
}
